export class ProductCategory {
  constructor(data) {
    this.id = data.id;
    this.name_en = data.name_en;
    this.name_zhhk = data.name_zhhk;
    this.name_zhcn = data.name_zhcn;
    this.productSubCategories = (data.productSubCategories || []).map(
      (sub) => new ProductCategory(sub)
    );
    if (data.productCategory) {
      this.productCategory = new ProductCategory(data.productCategory);
    }
  }
}
